/*
 * @Author: 陈大仙人
 * @Date: 2024-01-10 17:03:11
 * @LastEditors: 陈大仙人
 * @LastEditTime: 2024-01-11 11:49:08
 * @FilePath: /akx-pc-main/src/login/ad.js
 */
import { Message } from 'element-ui';

export default [
  {
    phone: "17766420335",
    title: "开通勤商",
    tipImg: "//img.ai.kxkx888.com/pc/banner/banner-qs-tip.jpg",
    banner: "//img.ai.kxkx888.com/pc/banner/banner-qs.gif",
    content: [
      "//img.ai.kxkx888.com/pc/banner/banner-qs-1.jpg",
      "//img.ai.kxkx888.com/pc/banner/banner-qs-2.jpg",
      "//img.ai.kxkx888.com/pc/banner/banner-qs-3.jpg",
      "//img.ai.kxkx888.com/pc/banner/banner-qs-4.jpg",
    ],
    event: (index, $vue) => {
      $vue.visable = true;
    },
  },
  {
    title: "开通收银系统",
    phone: "17766420335",
    tipImg: "//img.ai.kxkx888.com/pc/banner/banner-pos-tip.jpg",
    banner: "//img.ai.kxkx888.com/pc/banner/banner-pos.gif",
    content: [
      "//img.ai.kxkx888.com/pc/banner/banner-pos-1.jpg",
      "//img.ai.kxkx888.com/pc/banner/banner-pos-2.jpg",
    ],
    event: (index, $vue) => {
      $vue.visable = true;
    },
  },
  {
    title: "开通WMS系统",
    phone: "18994001828",
    tipImg: "//img.ai.kxkx888.com/pc/banner/banner-wms.png",
    banner: "//img.ai.kxkx888.com/pc/banner/banner-wms.png",
    content: [
      "//img.ai.kxkx888.com/pc/banner/banner-wms-1.png",
      "//img.ai.kxkx888.com/pc/banner/banner-wms-2.png",
      "//img.ai.kxkx888.com/pc/banner/banner-wms-3.png",
      "//img.ai.kxkx888.com/pc/banner/banner-wms-4.png",
    ],
    event: (index, $vue) => {
      if (index === 3) {
        navigator.clipboard.writeText("18994001828").then(
          () => Message.success("已复制，可电话/微信咨询"),
          () => Message.error("复制失败，请手动复制手机号")
        );
      }
    },
  },
];
